import mapValues from 'lodash/mapValues';
import isObjectLike from 'lodash/isObjectLike';
import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';
import { baseTheme } from '../base.js';
import { getComponentThemes } from '../components/index.js';
import { getTypographyTheme } from '../components/typography/index.js';
var sanitizeTheme = obj => {
  if (Array.isArray(obj)) return obj.map(sanitizeTheme);
  if (isPlainObject(obj)) {
    return mapValues(obj, value => isObjectLike(value) ? sanitizeTheme(value) : sanitize(value));
  }
  return obj;
};
var sanitize = s => {
  if (typeof s !== "string") return s;
  return s.replace(/</g, "&lt;").replace(/>/g, "&gt;");
};
var verifyPalette = palette => {
  // pass validation for falsy value
  if (!palette) {
    return true;
  }
  if (typeof palette !== "object") {
    return false;
  }
  // example value { 5: '#eee', 10: '#fff' ... }
  return !Object.entries(palette).some(param => {
    var [k, v] = param;
    if (typeof v !== "object") {
      return true;
    }
    if (k === "gradients") {
      return Object.values(v).some(v => !Array.isArray(v));
    }
    return Object.values(v).some(v => typeof v !== "string");
  });
};
// eslint-disable-next-line sonarjs/cognitive-complexity
var verifyThemeConfiguration = (defaultTheme, configuration) => {
  // pass validation for falsy value
  if (!configuration) {
    return true;
  }
  if (typeof configuration !== "object") {
    return false;
  }
  var hasInvalidValue = (theme, path) => {
    if (path === void 0) path = [];
    return Object.entries(theme).some(param => {
      var [k, v] = param;
      var currentPath = [...path, k];
      var currentDefaultValue = get(defaultTheme, currentPath);
      // wrong key
      if (typeof currentDefaultValue === "undefined") {
        console.error("Theme configuration does not exist: " + currentPath);
        return true;
      }
      // wrong value type, high level validation to avoid js errors, no guarantee for css
      if (typeof currentDefaultValue === "object" && (typeof v !== "object" || v === null)) {
        console.error("Theme configuration of this field should be provided as an object: " + currentPath);
        return true;
      }
      // escape for non-object, array and null
      if (typeof v !== "object" || Array.isArray(v) || v === null) {
        return false;
      }
      return hasInvalidValue(v, currentPath);
    });
  };
  return !hasInvalidValue(configuration);
};
var verifyComponentTheme = configuration => {
  var defaultComponentTheme = getComponentThemes(baseTheme);
  return verifyThemeConfiguration(defaultComponentTheme, configuration);
};
var verifyTypographyTheme = configuration => {
  var defaultTypographyTheme = getTypographyTheme(baseTheme, "font-family");
  return verifyThemeConfiguration(defaultTypographyTheme, configuration);
};
export { sanitize, sanitizeTheme, verifyComponentTheme, verifyPalette, verifyTypographyTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
